// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1-BD_","containerItemsCenter":"Skeleton_containerItemsCenter__Jcj-5"};